/**
 * Relative `/api/*` uses the Vite dev proxy → FastAPI on 127.0.0.1:8000 (see vite.config.js).
 * Dev default: try the proxy so document upload & geodata work when the backend is running.
 * Set `VITE_SKIP_BACKEND_PROXY=1` to silence /api calls when FastAPI is off.
 */
export function shouldUseRelativeBackendProxy() {
  if (import.meta.env.PROD) return true;
  if ((import.meta.env.VITE_API_BASE_URL || "").trim()) return true;
  if (import.meta.env.VITE_SKIP_BACKEND_PROXY === "1") return false;
  return true;
}
